// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1fc41","label":"Completed_label__1INcl"};